import { render, staticRenderFns } from "./PopularList.vue?vue&type=template&id=7725ba31"
import script from "./PopularList.vue?vue&type=script&lang=js"
export * from "./PopularList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports